import ProductBase from './base';

const base = new ProductBase();

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

export default class {
    constructor() {
        this.methods = {
            updateAddToCartEnableDisableOtherElements,
        };
    }

    init() {
        base.availability();
        base.addToCart();
        this.updateAttributesAndDetails();
        this.showSpinner();
        this.updateAttribute();
        this.updateAddToCart();
        this.updateAvailability();
        this.sizeChart();
        this.copyProductLink();
        this.handleRecommendedProductSetListeners();
        base.focusChooseBonusProductModal();
    }

    updateAttributesAndDetails() {
        $('body').on('product:statusUpdate', (e, data) => {
            const $productContainer = $(`.product-detail[data-pid="${data.id}"]`);

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    }

    showSpinner() {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', () => {
            $.spinner().start();
        });
    }

    updateAttribute() {
        $('body').on('product:afterAttributeSelect', (e, response) => {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    }

    updateAddToCart() {
        $('body').on('product:updateAddToCart', (e, response) => {
            // update local add to cart (for sets)
            const addToCart = $('button.add-to-cart').not('.slider button.add-to-cart')
            $(addToCart, response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            const enable = $('.product-availability').toArray().every((item) => $(item).data('available') && $(item).data('ready-to-order'));
            updateAddToCartEnableDisableOtherElements(!enable);
        });
    }

    updateAvailability() {
        $('body').on('product:updateAvailability', (e, response) => {
            $('div.availability', response.$productContainer)
                .attr('data-ready-to-order', response.product.readyToOrder)
                .attr('data-available', response.product.available);

            const $stockElem = $('div.availability .stock-message');
            if (!response.product.available) {
              $stockElem.css('color', 'var(--capocollo)').text($stockElem.attr('data-unavailable-msg'));
            } else {
              $stockElem.css('color', 'var(--arcala-green)').text($stockElem.attr('data-available-msg'));
            }

            $('.availability-msg', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                const allAvailable = $('.product-availability').toArray()
                    .every((item) => $(item).data('available'));

                const allReady = $('.product-availability').toArray()
                    .every((item) => $(item).data('ready-to-order'));

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    }

    sizeChart() {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            const url = $(this).attr('href');
            const $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url,
                    type: 'get',
                    dataType: 'json',
                    success(data) {
                        $prodSizeChart.append(data.content);
                    },
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        const $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', (e) => {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    }

    copyProductLink() {
        $('body').on('click', '#fa-link', (event) => {
            event.preventDefault();
            const $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(() => {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    }

    handleRecommendedProductSetListeners() {
        // Handle "include in product set" checkbox click
        $('body').on('click', '.js-include-to-product-set', (event) => {
            const $currentCheckbox = $(event.currentTarget);
            const pid = $currentCheckbox.attr('data-pid');
            const includeInSetChecked = $currentCheckbox.attr('data-include') === 'true';
            const $oppositeCheckbox = $(`.js-include-to-product-set[data-pid="${pid}"][data-include="${!includeInSetChecked}"]`);

            $currentCheckbox.parents('.js-recommended-product-set-tile').attr('data-included-in-set', !includeInSetChecked);
            $currentCheckbox.addClass('d-none');
            $oppositeCheckbox.removeClass('d-none');

            const currencySimbol = $('.js-recommended-product-set-tile').attr('data-currency');
            let totalAmount = 0;
            $('.js-recommended-product-set-tile[data-included-in-set="true"]').each((index, elem) => {
                totalAmount += parseFloat($(elem).attr('data-price'));
            });
            if (totalAmount === 0) {
                $('.js-recommended-product-set-add-to-cart').attr('disabled', true);
            } else {
                $('.js-recommended-product-set-add-to-cart').attr('disabled', false);
            }
            const totalAmountFormatted = totalAmount.toFixed(2).replace('.',',') + ' ' + currencySimbol;
            $('.js-product-set-total-amount').empty().text(totalAmountFormatted);
        });
    }
}
